import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../../data";
import { Reveal, Overline } from "./Reveal";
import { neutralizeWA } from "../../config";

export default function Reviews() {
  return (
    <section id="recensioni" className="relative bg-surface py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <Reveal><Overline>Recensioni</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-4xl sm:text-5xl">
              Cosa dicono i clienti a Roma
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              data-testid={`review-card-${i}`}
              className="relative rounded-2xl bg-white border border-gray-100 p-6 shadow-sm hover:shadow-lg transition-shadow duration-300"
            >
              <Quote size={28} className="text-brand-orange/25" />
              <div className="mt-2 flex items-center gap-0.5 text-brand-orange">
                {[...Array(r.rating)].map((_, s) => <Star key={s} size={15} fill="currentColor" />)}
              </div>
              <p className="mt-3 text-ink/75 text-[15px] leading-relaxed">{neutralizeWA(r.text)}</p>
              <div className="mt-5 pt-4 border-t border-gray-100">
                <p className="font-display font-bold text-navy">{r.name}</p>
                <p className="text-xs text-ink/50">{r.zone}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
